if ('NodeList' in window && !NodeList.prototype.forEach) {
    console.info('polyfill for IE11');
    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (let i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}

(function(){

    /*
        HOME ARROW
        $('.arrow-home').click(function(event) {
            $('body, html').animate({
                scrollTop: $(window).height()-$('header').outerHeight()*2},
                800, 'easeOutExpo');
        });
    */
   

    // Remove empty <p> tags created by tinymce
    const paragraph = document.querySelectorAll('p') || [];
	paragraph.forEach( e => (e.innerHTML.trim() === '') && e.parentNode.removeChild(e));


    $('.sym-slides').slick({
        accessibility: true
    });

    $('.amenities__slider').slick({
        arrows: true,
        fade: true
    });
    
    $('.gallery-quad__slider').slick({
        arrows: true,
        dots: false,
        fade: true,
        slide: '.gallery-slide',
        infinite: true
    });

    $('.gallery-quad__single').slick({
        arrows: true,
        dots: false,
        fade: true,
        slide: '.gallery-quad__item',
        infinite: true
    });

    //email signup animation 
	if(document.getElementById('email-signup')){
		document.getElementById('email-signup_FNAME').addEventListener('focus', function(){
			this.parentElement.classList.add('moved');
		})
		document.getElementById('email-signup_LNAME').addEventListener('focus', function(){
			this.parentElement.classList.add('moved');
		})
		document.getElementById('email-signup_email_address').addEventListener('focus', function(){
			this.parentElement.classList.add('moved');
		})

	}

    //CMS forms label animation
	if(document.getElementsByClassName('form-module__field').length > 0){
		let allffields = document.getElementsByClassName('form-module__field');
		
        for(let j = 0; j < allffields.length; j++){
            
            if(allffields[j].getElementsByTagName('input').length > 0){
                if(allffields[j].getElementsByTagName('input')[0].type.toLowerCase() != 'checkbox' && allffields[j].getElementsByTagName('input')[0].type.toLowerCase() != 'radio'){
                    allffields[j].getElementsByTagName('input')[0].addEventListener('focus', function(){
                        this.parentElement.classList.add('moved');
                    })
                }
            }
            if(allffields[j].getElementsByTagName('select').length > 0){
                allffields[j].getElementsByTagName('select')[0].addEventListener('focus', function(){
                    this.parentElement.classList.add('moved');
                })
            }
            if(allffields[j].getElementsByTagName('textarea').length > 0){
                allffields[j].getElementsByTagName('textarea')[0].addEventListener('focus', function(){
                    this.parentElement.classList.add('moved');
                })
            }
        }
	}

    $('.venues-slider__slider').slick({
        arrows: true,
        dots: false,
        slidesToShow: 3,
        slidesToScroll: 1,
        infinite: true,
        responsive: [
            {
              breakpoint: 768,
              settings: {
                fade: false,
                slidesToScroll: 1,
                centerMode: true,
                centerPadding: '20px',
                slidesToShow: 1,
              }
            },
        ]

    });

    if(document.getElementsByClassName('js-accordion-title')){        
        document.querySelectorAll('.accordion').forEach((accordion) => {
            accordion.querySelectorAll('.js-accordion-title').forEach((itemHead) => {
                itemHead.addEventListener('click', (e) => {
                    accordion.querySelectorAll('.js-accordion-item').forEach((item) => {
                        if (itemHead.parentNode !== item) item.classList.remove('open');
                    });
                    itemHead.parentNode.classList.toggle('open');
                });
            });
        });
    }

    if(document.querySelector('.text-modules-wrapper')){
        document.querySelectorAll('.text-modules-wrapper .text-modules').forEach((item)=>{
            item.classList.add('animate-fade','top');
        });
    }

    if(document.querySelector('.form-module-wrapper')){
        document.querySelectorAll('.form-module-wrapper .form-module').forEach((form)=>{
            form.classList.add('animate-fade','top');
        });
    }

	// ------- tablet / mobile menu cta -------
    if(document.getElementById('menu-sm-cta-js')){
        let menuMobile = document.getElementById('box-primary-nav');
        document.getElementById('menu-sm-cta-js').addEventListener('click', function(e){
            e.preventDefault();
            if(menuMobile.classList.contains('closed')){
                document.getElementById('box-primary-nav').classList.remove('closed');
                this.classList.add('closed');
                document.getElementById('menutext-js').innerHTML = 'Close';
                document.getElementById('header').classList.add('open-menu');
                document.querySelector("body").classList.add('noScroll')
                if(lastScrollTop < 80){
                    document.getElementById('header').classList.remove('open-menu');
                }
            } else {
                document.getElementById('box-primary-nav').classList.add('closed');
                this.classList.remove('closed');
                document.getElementById('menutext-js').innerHTML = 'Menu';
                document.querySelector("body").classList.remove('noScroll');
            }
        });
        document.getElementById("close-menu").addEventListener("click", function () { 
            document.getElementById('box-primary-nav').classList.add('closed');
            this.classList.remove('open');
            document.getElementById('menutext-js').innerHTML = 'Menu';
            document.querySelector("body").classList.remove('noScroll');
        });
    }
// ------- End tablet / mobile menu cta -------

// ------- Custom gallery -------
    // const customLightboxFooter = new LBX(".js-my-lightbox", {
    //     fullScreen:true,
    // });

    // if( customLightboxFooter != null ){
    //     customLightbox.fullScreen =true
    // }
// ------- End Custom gallery -------

    // ------- Menu scroll logo add middle  -------
    //logo Special class
	const logocontent = document.querySelector("#privary-navigation .logo");
	if(logocontent){
		logocontent.parentElement.classList.add("privary-navigation__logo")
	}

    // table section
    const tablesResp = document.querySelectorAll('.table-js table');
    if (tablesResp.length) {
        tablesResp.forEach((tablei) => {
            let tableresponsive = document.createElement('div')
            tableresponsive.classList.add('tableHold')
            tablei.parentNode.insertBefore(tableresponsive, tablei)
            tableresponsive.append(tablei)
            const ths = tablei.querySelectorAll('tr:first-child > *')
            tablei.querySelectorAll('tr + tr').forEach((row) => {
                const tds = row.querySelectorAll('td')
                let i = 0
                for (i; i < tds.length; i++) {
                    tds[i].setAttribute('data-label', ths[i].textContent)
                }
            })
            const rowHeads = tablei.querySelectorAll('tr td:first-child')
            rowHeads.forEach((ele) => {
                ele.addEventListener('click', (ev) => {
                    ele.closest('tr').classList.toggle('active')
                })
            })
        })
    }
})();
